module.exports = __webpack_public_path__ + "static/img/pre_pay_inHos.96e29b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/tcms/img/pre_pay_inHos.png
// module id = BKvA
// module chunks = 15